import { SelfServiceSteps } from 'modules/selfServices/types/SelfServiceSteps';
import { ConnectionTypeLogin } from 'modules/dealers/types/ContextResponse';
import { KIOSK_LOCATION, SHAREBOX_KEY } from 'components/SelfServices/Steps/common';

import type Flow from 'types/Flow';
import { REOPEN_VERIFY } from '../common';

export type ShareboxI32ReopenSteps = SelfServiceSteps.REOPEN_VERIFY | SelfServiceSteps.KIOSK_LOCATION | SelfServiceSteps.SHAREBOX_KEY;

// Alias 'INDOOR' flow
const SHAREBOX_I32_REOPEN_STEPS: Flow<ShareboxI32ReopenSteps> = {
  REOPEN_VERIFY: {
    ...REOPEN_VERIFY,
    next: SHAREBOX_KEY.key,
  },
  // This one is shown in 'remote' flow, i.e. when the user is using their phone
  KIOSK_LOCATION: {
    ...KIOSK_LOCATION,
    key: SHAREBOX_KEY.key,
    previous: REOPEN_VERIFY.key,
    data: {
      ...KIOSK_LOCATION.data,
      isVisible: (_, config) => config.connectionTypes?.includes(ConnectionTypeLogin.TOKEN),
    },
  },
  // This one is shown when the user is using the kiosk
  SHAREBOX_KEY: {
    ...SHAREBOX_KEY,
    previous: REOPEN_VERIFY.key,
    data: {
      ...SHAREBOX_KEY.data,
      isVisible: (_, config) => config.connectionTypes?.includes(ConnectionTypeLogin.MFA),
    },
  },
};

export default SHAREBOX_I32_REOPEN_STEPS;
